import React from 'react';
import ComponentWrapper from '../../common/ComponentWrapper';
import CommonStyles from '../../common/CommonStyles';
import { withStyles } from '@mui/styles';
import { Paper } from '@mui/material';

import SignupEmail from './components/SignupEmail';
import SignupPassword from './components/SignupPassword';
import PasswordRecoverAndAccountCreate from '../../common/PasswordRecoverAndAccountCreate';

import { emojiesSuccess, emojiesRedirect } from '../../utils';

const styles = {
  paper: {
    width: 'fit-content',
    minWidth: '400px',
    margin: 'auto',
  },
  linkBlue: {
    fontSize: '12px',
    textDecoration: 'none',
    color: '#347CFF',
    cursor: 'pointer',
    '&:hover': {
        textDecoration: 'underline',
    },
  },
  messageBlock: {
    display: 'flex',
    fontSize: '15px',
    flexDirection: 'column',
    color: '#168CCE',
    padding: 15,
    background: '#E1EBF1',
  },
  messageTitle: {
    fontSize: '15px',
    marginBottom: '8px',
    color: '#222029',
    lineHeight: '20px',
    '& a': {
      textDecoration: 'none',
      color: '#347CFF',
      cursor: 'pointer',
      fontWeight: 'bold',
      '&:hover': {
          textDecoration: 'underline',
      },
    },
  },
  mainContainer: {
    padding: '40px',
    width: '400px',
    margin: '50px auto',
    justifyContent: 'center',
    boxShadow: '0px 3px 5px rgba(0, 0, 2, 0.1)',
  },
  titleContainer: {
    margin: 'auto',
    padding: '10px',
    minWidth: '300px',
    width: 'fit-content',
    textAlign: 'center',
    display: 'grid'
  },
  dialogTitle: {
    fontSize: 20,
    marginBottom: '16px',
    fontWeight: 'bold',
    color: '#222029',
  },
  dialogSubTitle: {
    fontSize: 14,
    marginBottom: '5px',
    color: '#222029',
  },
  textRole: {
    fontSize: '15px',
    textDecoration: 'none',
    minWidth: '300px',
    width: 'fit-content',
    textAlign: 'center',
    color: '4c4c4c',
    marginBottom: '20px',
  },
  backIcon: {
    zIndex: 5,
    fontSize: '20px',
    color: '#878787',
    '&:hover': {
      cursor: 'pointer',
      color: '#4C4C4C',
    },
  },
  okBtn: {
    height: '37px',
    marginTop: '10px',
    width: '100%',
    borderRadius: '20px',
    backgroundColor: '#222029',
    color: 'white',
    opacity: '0.8',
    '&:hover': {
        opacity: '1.0',
        backgroundColor: '#222029',
    },
  },
  insetShadowInput: {
    backgroundColor: '#F5F5F5',
    boxShadow: 'inset 0px 1px 1px #D6D6D6',
    width: 'calc(100% - 8px)',
    fontSize: 14,
    height: '30px',
    padding: '4px',
    border: 'none',
    '&:focus': {
        outline: '1px solid #70b8ff'
    },
  },
  ...CommonStyles,
};

class SignupPage extends ComponentWrapper {
  state = {
    hash: '',
    message: '',
    hashData: {},
    respData: {},
    loading: false,
    showEmail: false,
    showMessage: false,
    passwordRecoveryOpen: false,
  };

  componentDidMount() {
    document.title="Sign Up | Milkyweb";

    const search = this.props.location.pathname.split('/');
    const hash = search[2];

    if (!hash && window.location.host === 'mlkwb.ai') {
      this.getInvitation('6VqeJLBV');
      this.setState({ hash: '6VqeJLBV' });
    }
    else {
      this.getInvitation(hash);
      this.setState({ hash });
    }
  };

  getInvitation = (hash) => {
    this.get({
      url: `/get_invitation/${hash}`,
      cb: (hashData) => {
        if (hashData.is_account_in_invitation_role) window.location.replace(`http://${window.location.host}/dashboard`);
        
        else {
          if (hashData.expired) {
            this.setState({ showMessage: true,  message: hashData.message });
          }

          this.setState({ hashData });
        }
      },
    });
  };

  showEmailScreen = () => {
    this.setState({ showEmail: true });
  };

  submitEmail = (e) => {
    const { hash } = this.state;

    this.setState({ loading: true });

    this.get({
      url: `/rest/check_email_and_invite?hash=${hash}&email=${e}`,
      cb: (respData) => {
        if (respData._status === 'error') {
          this.setState({ loading: false });
        } else {
          if (respData.is_account_in_invitation_role) window.location.replace(`http://${window.location.host}/dashboard`);
          else this.setState({ respData, showMessage: true, message: respData.message, loading: false });
        }
      },
    });
  };

  submitPassword = (password, email) => {
    const { hash } = this.state;

    this.setState({ loading: true });

    this.postWithData({
      url: `/rest/do_sign_up`,
      data: {
        password: password,
        email: email,
        code: hash
      },
      cb: (data) => {
        if (data._status === 'error') {
          this.setState({ loading: false });
        } else {
          this.setState({ respData: data, showMessage: true, message: data.message, loading: false});
        }
      }
    });
  };

  backToMainAuthWindow = () => {
    this.setState({ passwordRecoveryOpen: false });
  };

  openRecoverPassword = () => {
    this.setState({ passwordRecoveryOpen: true });
  };

  render() {
    const { classes } = this.props;
    const { hashData, respData, message, showMessage, passwordRecoveryOpen, loading } = this.state;

    let randomEmoji;

    if (showMessage) {
      if (respData.expired || hashData.expired) { // respData.is_account_in_invitation_role || hashData.is_account_in_invitation_role || 
        randomEmoji = emojiesRedirect[Math.floor(Math.random() * emojiesRedirect.length)];
      } else {
        randomEmoji = emojiesSuccess[Math.floor(Math.random() * emojiesSuccess.length)];
      }
    }

    return (
      <div>
        {Object.keys(hashData).length !== 0 &&
          <div>
            <Paper className={classes.mainContainer}>
              <div className={`${classes.justifyCenter} ${classes.mb30}`}>
                {window.location.hostname === 'mlkwb.ai' ?
                  <img src="/images/Milkyweb_green_S_site.svg" alt="MilkywebAi logo" />
                  :
                  <img src="/images/Milkyweb_blue_S_site.svg" alt="Milkyweb logo" />
                }
              </div>
              {passwordRecoveryOpen ?
                <PasswordRecoverAndAccountCreate
                  classes={classes}
                  backToMainAuthWindow={this.backToMainAuthWindow}
                />
              :
              <div>
                {hashData.setup && hashData.setup.title ?
                  <div className={`${classes.mb20} ${classes.titleContainer}`}>
                    {/* <h3 className={classes.mb10}>
                      Sign up
                    </h3> */}
                    <div className={`${classes.dialogTitle}`}>
                      Sign up
                    </div>
                    <div className={`${classes.alignJustifyCenter} ${classes.dialogSubTitle}`}>
                      <span style={{ color: 'gray' }}>{'to'}</span>&nbsp;
                      <span style={{ fontWeight: 'bold' }}>{hashData.setup.title.charAt(0).toUpperCase() + hashData.setup.title.slice(1)}</span>
                    </div>
                    {hashData.role ?
                    <div className={`${classes.alignJustifyCenter} ${classes.dialogSubTitle}`}>
                      <span style={{ color: 'gray' }}>{'as'}</span>&nbsp;
                      <span style={{ fontWeight: 'bold' }}>{hashData.role.title}</span>
                    </div>
                    : null}
                  </div>
                : null}

                {showMessage ? (
                  <div className={classes.messageBlock}>
                    <div className={classes.messageTitle} style={{alignSelf: 'center'}} dangerouslySetInnerHTML={{ __html: message }} />
                    <div style={{fontSize: 40, alignSelf: 'center'}}> {randomEmoji} </div>
                  </div>
                ) : !hashData.is_private ?
                  <SignupEmail
                    style={{ margin: '50px auto 0 auto' }}
                    classes={classes}
                    loading={loading}
                    hashData={hashData}
                    submitEmail={this.submitEmail}
                  />
                :
                  <SignupPassword
                    style={{ margin: '50px auto 0 auto' }}
                    classes={classes}
                    loading={loading}
                    hashData={hashData}
                    openRecoverPassword={this.openRecoverPassword}
                    showEmailScreen={this.showEmailScreen}
                    submitPassword={this.submitPassword}
                  />
                }
              </div>}
            </Paper>
          </div>
        }
      </div>
    );
  }
};

export default (withStyles(styles)(SignupPage));



